/*
 * strova bundle
 * Mengen-Bundles im Kaufbereich.
 *
 * Die Auswahl setzt ausschliesslich das versteckte Feld "quantity" im bestehenden
 * Produktformular. Es wird keine Variante gewechselt, keine ID veraendert und kein Preis
 * berechnet — die angezeigten Betraege kommen serverseitig aus Liquid, der tatsaechliche
 * Rabatt aus dem Shopify-Rabatt. Das Frontend taeuscht keinen Preis vor.
 */
(function () {
  'use strict';

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-st-bundle]').forEach(function (bundle) {
      if (bundle.dataset.stReady) return;
      bundle.dataset.stReady = '1';

      var form = bundle.closest('form');
      var quantityInput = form ? form.querySelector('[data-st-quantity]') : null;
      var stickyPrice = document.querySelector('[data-st-sticky-price]');
      var rows = Array.prototype.slice.call(bundle.querySelectorAll('.st-bundle__row'));

      function select(row) {
        rows.forEach(function (item) { item.classList.toggle('is-selected', item === row); });

        var input = row.querySelector('[data-st-bundle-option]');
        if (!input) return;
        input.checked = true;

        if (quantityInput) quantityInput.value = input.dataset.qty || '1';

        var total = row.querySelector('.st-bundle__now');
        if (stickyPrice && total) stickyPrice.textContent = total.textContent.trim();
      }

      rows.forEach(function (row) {
        var input = row.querySelector('[data-st-bundle-option]');
        if (input) input.addEventListener('change', function () { select(row); });
      });

      var preselected = bundle.querySelector('.st-bundle__row.is-selected') || rows[0];
      if (preselected) select(preselected);
    });
  }

  var strova = (window.strova = window.strova || {});
  strova.initBundles = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
